import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { getConsent } from "@/lib/consent";

const visitorId = () => {
  let v = localStorage.getItem("aic_vid");
  if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("aic_vid", v); }
  return v;
};

let sentReferrer = false;
let last = { path: null, at: 0 };

export const RouteTracker = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) { window.scrollTo(0, 0); }
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    if (last.path === pathname && Date.now() - last.at < 1000) return;
    last = { path: pathname, at: Date.now() };
    const referrer = sentReferrer ? null : document.referrer || null;
    sentReferrer = true;
    const ok = getConsent() === "accepted";
    api.post("/track", ok ? { path: pathname, referrer, visitorId: visitorId() } : { path: pathname, referrer, anonymous: true }).catch(() => {});
  }, [pathname]);
  return null;
};
